/* eslint-disable eqeqeq */
/* eslint-disable no-invalid-this */
/* eslint-disable @typescript-eslint/no-this-alias */
import WinxnetUtility from "../../../vendor/WinxnetCommon/Winxnet.Utility";
import { IPromise, IHttpService, ILogService, IRootScopeService, IWindowService, default as angular } from "angular";
import { getExceptionMessage, dropStackFrames } from "../data-utils";

export interface UtilityService {

    globalBroadcast(event, args): void;
    showLoading(): void;
    hideLoading(): void;
    apiUrl: string;
    utility: WinxnetUtility;
    transmitData(settings): any;
    getData(settings): any;
    postData(settings): any;
    safeApply($scope, apply): any;
    /**
     * Get the exception message from the $http exception object.
     */
    getExceptionMessage(ex: any): string;
    /**
     * Show a loading spinner until the promise resolves.
     * @return Promise that resolves once the loading spinner is hidden.
     */
    showLoadingUntilResolved<T>(promise: IPromise<T> | Promise<any>): IPromise<T>;
    alertOnError<T>(promise: IPromise<T> | Promise<T>, alertTitle: string): IPromise<T> | Promise<T>;
    alertOnError(promise: IPromise<any> | Promise<any>, alertTitle: string): IPromise<any> | Promise<any>;
    containsInvariant(wholeString: string, instance: string): boolean;
    equalsInvariant(wholeString: string, instance: string): boolean;
    /**
     * Debounce the given function so that it cannot be fired more than once
     * over the course of the given timeout.
     * @param func The function to be fired.
     * @param wait The number of milliseconds to wait before clearing the timeout.
     * @param immediate If true, trigger the function on the leading edge.
     * @returns The original function wrapped in a debouncer.
     * @deprecated This implementation does not implement a full debounce spec; it may be removed
     *   eventually, so using lodash debounce as a substitute instead is recommended.
     */
    debounce(func: (...args: any[]) => any, wait: number): (...args: any) => void;
    debounce(func: (...args: any[]) => any, wait: number, immediate: boolean): (...args: any) => void;
    /**
     * Convert the given query object into a query string
     * @returns The converted query string.
     */
    queryStringify(query: any): string;
    /**
     * Move the given item within the list of items to its new index, in place.
     * @param items The list of items within which the movedItem has moved.
     * @param movedItem The item that has moved.
     * @param index The index to which the moved item has moved.
     * @template T The generic type of item contained in the list of items.
     * @returns The mutated original list of items.
     */
    moveItem<T>(items: T[], movedItem: T, index: number): T[];
    getModelStateErrors(modelState): any;
}

export function UtilityServiceFactory($http: IHttpService, $log: ILogService,
    $rootScope: IRootScopeService, $window: IWindowService): UtilityService {
    'ngInject'

    let loadingCount = 0;

    const utilitySvc = {

        globalBroadcast: function (event, args) {
            $rootScope.$broadcast('rootScope:' + event, args);
        },

        showLoading: function () {
            loadingCount += 1;

            if (loadingCount === 1) {
                $rootScope.$broadcast('showLoading');
            }
        },

        hideLoading: function () {
            loadingCount -= 1;
            if (loadingCount <= 0) {
                loadingCount = 0;
                $rootScope.$broadcast('hideLoading');
            }
        },

        apiUrl: $window.siaaApiUrl,

        utility: $window.utility,

        transmitData: function (settings) {
            if (angular.isUndefined(settings.dataType)) {
                settings.dataType = "json";
            }

            settings.headers = $.extend(settings.headers, { Authorization: $window.apexToken });
            settings.url = this.apiUrl + settings.url;

            if (($ as any).__jquery_xdomain__) {
                // shim for IE CORS
                // jquery.ie.cors.js

                const response: any = {
                    config: settings,
                };

                // create a fake http promise
                // http://docs.angularjs.org/api/ng.$http
                // this does not support all of the angular $http options.
                // Typical $q does not provide the methods we want (success and error)
                const httpPromise = {
                    _successFunc: [],
                    _errorFunc: [],
                    success: function (successFunc) {
                        if (angular.isFunction(successFunc)) {
                            this._successFunc.push(successFunc);
                        }
                        return this;
                    },
                    then: function (successFunc, errorFunc) {
                        if (angular.isFunction(successFunc)) {
                            this._successFunc.push(successFunc);
                        }
                        if (angular.isFunction(errorFunc)) {
                            this._errorFunc.push(errorFunc);
                        }
                        return this;
                    },
                    error: function (errorFunc) {
                        if (angular.isFunction(errorFunc)) {
                            this._errorFunc.push(errorFunc);
                        }
                        return this;
                    }
                };

                $.ajax(settings)
                    .done(function (data, textStatus, jqXHR) {
                        response.data = data;
                        response.status = jqXHR.status;
                        response.headers = jqXHR.getResponseHeader;
                        angular.forEach(httpPromise._successFunc, function (func) {
                            func(response.data, response.status, response.headers, response.config);
                        });
                        $rootScope.$apply();
                    })
                    .fail(function (jqXHR) {
                        response.status = jqXHR.status;
                        response.headers = jqXHR.getResponseHeader;
                        angular.forEach(httpPromise._errorFunc, function (func) {
                            func(null, response.status, response.headers, response.config);
                        });
                        $rootScope.$apply();
                    });

                return httpPromise;
            } else {
                // normal flow for browsers which process CORS correctly (i.e. non-IE, IE 10 and greater)
                return $http(settings);
            }
        },

        getData: function (settings) {
            if (angular.isString(settings)) {
                settings = { url: settings };
            }
            if (angular.isUndefined(settings.method)) {
                settings.method = "GET";
            }
            return utilitySvc.transmitData(settings);
        },

        postData: function (settings) {
            if (angular.isString(settings)) {
                settings = { url: settings };
            }
            if (angular.isUndefined(settings.method)) {
                settings.method = "POST";
            }
            if (angular.isUndefined(settings.contentType)) {
                settings.contentType = "application/json;charset=utf-8";
            }
            return utilitySvc.transmitData(settings);
        },

        safeApply: function ($scope, apply) {
            const phase = $scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                // apply already happening
                if (angular.isFunction(apply)) {
                    return apply($scope);
                }
            } else {
                return $scope.$apply(apply);
            }
        },
        getExceptionMessage: getExceptionMessage,
        showLoadingUntilResolved: showLoadingUntilResolved,
        alertOnError: alertOnError,
        containsInvariant: containsInvariant,
        equalsInvariant: equalsInvariant,
        debounce: debounce,
        queryStringify: queryStringify,
        moveItem: moveItem,
        getModelStateErrors: getModelStateErrors
    };

    return utilitySvc;

    function getModelStateErrors(modelState) {
        //Convert the model state dictonary to array and faltten the result
        const modelStateArray = [].concat(...Object.values(modelState));
        //Remove the duplicate error messages
        return [...new Set(modelStateArray)];
    }

    function containsInvariant(wholeString, instance) {
        return !instance || (wholeString || "").toLowerCase().indexOf((instance || "").toLowerCase()) > -1;
    }

    function equalsInvariant(wholeString, instance) {
        return (wholeString || "").toLowerCase() === (instance || "").toLowerCase();
    }

    /**
     * Debounce the given function so that it cannot be fired more than once
     * over the course of the given timeout.
     * @param func The function to be fired.
     * @param wait The number of milliseconds to wait before clearing the timeout.
     * @param immediate If true, trigger the function on the leading edge.
     * @returns The original function wrapped in a debouncer.
     */
    function debounce(func: (...args: any[]) => any, wait: number, immediate = false): (...args: any) => void {
        let timeout;
        return function (...args: any[]) {
            const context = this;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    /**
     * Show a loading spinner until the promise resolves.
     * @param {Promise} promise
     * @param {any} alertTitle
     * @return {Promise} Promise that resolves once the loading spinner is hidden.
     */
    function showLoadingUntilResolved(promise) {
        utilitySvc.showLoading();
        return promise.catch(function () { }).then(utilitySvc.hideLoading);
    }

    function alertOnError(promise, alertTitle) {
        // Capture original context of the alert handler for better logging tracking.
        const context = new Error();
        return promise.catch(function (ex) {
            if (ex instanceof Error) {
                // Augment with the alertOnError trace. Drop the alertOnError frame.
                ex.stack += "\n" + dropStackFrames(context.stack, 1);
                $log.error(ex, alertTitle);
            } else {
                // Log the context instead of the rejected value to retain original stack trace information.
                // Otherwise, the current stack trace is captured, which will be within AngularJS context.
                context.message = getExceptionMessage(ex);
                $log.error(context, alertTitle, ex);
            }
            alert(alertTitle + ": " + getExceptionMessage(ex));
        });
    }

    /**
     * Convert the given query object into a query string
     * @param {any} query
     * @returns {string} The converted query string.
     */
    function queryStringify(query) {
        if (!query) {
            return "";
        }
        return Object.keys(query).reduce(function (qs, key) {
            if (query[key] !== undefined && query[key] !== null) {
                const prefix = qs ? "&" : "?";
                if (query[key].length !== undefined && query[key].forEach) {
                    // For list-like objects, append the key for each item in the list.
                    query[key].forEach(function (item) {
                        qs += prefix + (key + "=" + encodeURIComponent(item))
                    });
                } else {
                    qs += prefix + (key + "=" + encodeURIComponent(query[key]));

                }
            }
            return qs;
        }, "");
    }

    /**
     * Move the given item within the list of items to its new index, in place.
     * @param {T[]} items The list of items within which the movedItem has moved.
     * @param {T} movedItem The item that has moved.
     * @param {number} index The index to which the moved item has moved.
     * @template T The generic type of item contained in the list of items.
     * @returns {T[]} The mutated original list of items.
     */
    function moveItem(items, movedItem, index) {
        const itemsCopy = items.splice(0, items.length).filter(function (item) {
            return item !== movedItem;
        });

        for (let i = 0; i < itemsCopy.length + 1; i++) {
            if (i === index) {
                items.push(movedItem);
            }
            if (i < itemsCopy.length) {
                items.push(itemsCopy[i]);
            }
        }
        return items;
    }
}
